exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".saved-filter-wrapper .btn-filter{padding-left:0;padding-right:0}.saved-filter-wrapper .saved-filter-item{padding:1rem 1.15rem!important}.saved-filter-wrapper .saved-filter-item:hover{color:var(--brand-primary)}.saved-filter-wrapper .saved-filter-item:focus{background:transparent}.saved-filter-wrapper .saved-filter-item.active{color:var(--brand-primary)}.saved-filter-wrapper .saved-filter-dropdown-menu{min-width:min(380px,calc(100vw - 2rem));max-width:calc(100vw - 2rem);margin-top:.75rem}.saved-filter-wrapper .saved-filter-dropdown-menu .dropdown-search-result-wrapper{max-height:190px;overflow-y:auto}", ""]);

// exports
